/* eslint-disable react/display-name */
import React, { memo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { ObservationDetails } from './observationDetails';
import { AlmanacDetails } from './almanacDetails';
import { WidgetHeader } from '../common/widgetHeader.jsx';
import { reduxConnect } from '../../common';
import { translate } from '../../common/translation/translate';
import { getWidgetHeaderText } from '../../common/utilities/getWidgetHeaderUtil';

const weatherDetailsHeaderTxt = translate('weatherDetails');

const mapStoreStateToProps = storeState => {

    const appState = storeState.appState.appState || {};

    const { CityName: cityName, TerritoryAbbr: stateAbbreviation, DisplayCompositeName: displayCompositeName } = appState?.user?.ActiveLocation?.Locality || {};

    return {
        cityName,
        stateAbbreviation,
        displayCompositeName
    };
};

const mapDispatchToProps = {

};

export const WeatherDetailsWidget = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo(({ cityName, stateAbbreviation, displayCompositeName }) => {
    
    const widgetHeaderText = cityName && stateAbbreviation ? getWidgetHeaderText({ widgetTitle:weatherDetailsHeaderTxt, cityName, stateAbbreviation }) : getWidgetHeaderText({ widgetTitle:translate('weatherForecast'), displayCompositeName }) ;
    return (
        <WeatherDetailsContainer>
            <WidgetHeader headerText={widgetHeaderText} />
            <WeatherDetailsBody>
                <WeatherDetailsBlockList>
                    <ObservationDetails />
                    <AlmanacDetails />
                </WeatherDetailsBlockList>
            </WeatherDetailsBody>
        </WeatherDetailsContainer>
    );

}));

WeatherDetailsWidget.displayName = 'WeatherDetailsWidget';

WeatherDetailsWidget.propTypes = {
    displaycompositeName: PropTypes.string,
    cityName: PropTypes.string,
    stateAbbreviation: PropTypes.string
};

const WeatherDetailsContainer = styled.div`
    width: 100%;
    height: 250px;
    background-color: #F9F9F9;
    color: #000000;
    borderRadius: 2px;
`;

const WeatherDetailsBody = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px;
    height: 213px;
`;

const WeatherDetailsBlockList = styled.ul`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    list-style-type: none;
    padding-left: 0;
    font-size: 0;
    height: 100%;
`;
